import type { ArticleCategoryShallow } from "@brookbush/types";

import Link from "next/link";
import type React from "react";

import CategoryItem from "./CategoryItem";
import Accordion from "~/components/Accordion";

interface ArticlesCategoriesProps {
	shallowCategories: Array<ArticleCategoryShallow>;
}
const ArticlesCategories: React.FC<ArticlesCategoriesProps> = ({
	shallowCategories,
}) => {
	return (
		<div className="relative flex flex-col gap-5">
			<Link href="/articles/">
				<h1 className="font-semibold text-2xl text-slate-700 transition-opacity duration-200 hover:opacity-50 dark:text-white">
					Articles
				</h1>
			</Link>
			<div className="flex flex-col gap-2">
				<div className="flex flex-col gap-1 rounded-xl bg-gradient-to-br from-sky-500 to-sky-700 p-2 font-semibold">
					<Accordion key="featured">
						<CategoryItem
							category={{ slug: "featured", title: "Featured Articles" }}
							featuredCategory={true}
							routeName="articles"
						/>
					</Accordion>
					<Accordion key="latest">
						<CategoryItem
							category={{ slug: "latest", title: "Latest Articles" }}
							featuredCategory={true}
							routeName="articles"
						/>
					</Accordion>
					<Accordion key="scholarly">
						<CategoryItem
							category={{
								slug: "scholarly",
								title: "Scholarly Articles",
							}}
							featuredCategory={true}
							routeName="articles"
						/>
					</Accordion>
				</div>
				{shallowCategories?.map(({ subCategories: children, ...category }) => (
					<Accordion key={category.slug}>
						<CategoryItem
							category={{ ...category, children }}
							routeName="articles"
						/>
					</Accordion>
				))}
			</div>
		</div>
	);
};

export default ArticlesCategories;
